import { IFormJBPHPContactChangeRequest } from 'legacy/lut/classes/models/partner360/IFormHPContacts'

export interface ICockpitSalesTeamContact extends IFormJBPHPContactChangeRequest {
  managementContact?: IFormJBPHPContactChangeRequest
  requestOnly?: boolean
}

export const buildSalesTeamItems = (records: IFormJBPHPContactChangeRequest[]) => {
  const items: ICockpitSalesTeamContact[] = records.map((record) => ({
    ...record,
    managementContact: record,
    requestOnly: record.TicketId > 0 && record.RequestAction === 'Add',
  }))
  return { items, people: items.filter((item) => !item.requestOnly) }
}
